// react
import { fromJS } from "immutable";
// dependencies
import PropTypes from "prop-types";
import React from "react";

import { faTimes } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import SelectInput from "../../../../components/Inputs/SelectInput";

// components
// utils
// styles
import css from "../SftpSettings.module.scss";

const AddBackupField = (props) => {
	const { backupIDField, setBackupIDField, companyCustomFields } = props;

	const handleChange = (value) => {
		const newBackupIDField = companyCustomFields.filter((field) => field.id === value)[0].id;
		setBackupIDField(newBackupIDField);
	};

	const clearBackupField = () => {
		setBackupIDField(null);
	};

	const allowedCustomFields = companyCustomFields.filter((field) => field.name !== "Email");

	return (
		<div>
			<div className={css.inputWrapper}>
				<div className={css.modalDescription}>Backup Field (Optional):</div>
				<div className={css.moreDescription}>
					Select a backup employee field to be used for identification when email can&apos;t be found.
				</div>
				<div>
					<div className={css.modalInput} style={{ width: "90%", float: "left" }}>
						<SelectInput
							value={backupIDField}
							results={fromJS(
								allowedCustomFields.map((customField) => ({
									id: customField.id,
									label: customField.name,
								}))
							)}
							onChange={(val) => {
								handleChange(val);
							}}
						/>
					</div>
					<div style={{ width: "10%", float: "right", top: "12px" }}>
						<span
							className={css.inputIcon}
							onClick={() => {
								clearBackupField();
							}}
						>
							<FontAwesomeIcon icon={faTimes} data-testid={faTimes.iconName} />
						</span>
					</div>
				</div>
			</div>
		</div>
	);
};

AddBackupField.propTypes = {
	backupIDField: PropTypes.string || null,
	setBackupIDField: PropTypes.func.isRequired,
	companyCustomFields: PropTypes.array.isRequired,
};

export default AddBackupField;
